<template>
  <div class="content">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{mode}} invoice</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <tabs
            ref="tabs1"
            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
            tabContentClasses="card shadow"
          >
            <tab-pane id="main">
              <span slot="title">Main</span>
              <validation-observer ref="formvalid">
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Class" :rules="{required: mode === 'Create'}" name="class">
                        <span v-if="mode === 'Edit'">{{payment.code}}. {{payment.coursetitle}}</span>
                        <el-select
                          v-if="mode === 'Create'"
                          class="select-primary pagination-select"
                          v-model="payment.classid"
                          placeholder="Course"
                        >
                          <el-option
                            class="select-primary"
                            v-for="item in classes"
                            :key="item.id"
                            :label="item.code + '. ' + item.coursetitle "
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Payer type"
                        :rules="{required: mode === 'Create'}"
                        name="payer type"
                      >
                        <span v-if="mode === 'Edit'">{{payment.payertypename}}</span>
                        <el-select
                          v-if="mode === 'Create'"
                          class="select-primary pagination-select"
                          v-model="payment.payertype"
                          placeholder="Payer type"
                        >
                          <el-option
                            class="select-primary"
                            v-for="item in types"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        type="number"
                        :label="'Amount' + (payment.payertype === 1 ? ' (per each student)' : '')"
                        :placeholder="'Amount' + (payment.payertype === 1 ? ' (per each student)' : '')"
                        v-model="payment.amount"
                        name="amount"
                      ></base-input>
                    </div>

                    <div class="col-lg-6" v-if="payment.payertype === 2">
                      <base-input
                        type="text"
                        rules="required"
                        label="Payer name"
                        placeholder="Payer name"
                        v-model="payment.payername"
                        name="Payer name"
                      ></base-input>
                    </div>
                    <div class="col-lg-6" v-if="payment.payertype === 2">
                      <base-input
                        type="text"
                        rules="required"
                        label="Contact person"
                        placeholder="Contact person"
                        v-model="payment.contactperson"
                        name="Contact person"
                      ></base-input>
                    </div>
                    <div class="col-lg-6" v-if="payment.payertype === 2">
                      <base-input
                        type="text"
                        rules="required"
                        label="Payer phone"
                        placeholder="Payer phone"
                        v-model="payment.payerphone"
                        name="Payer phone"
                      ></base-input>
                    </div>
                    <div class="col-lg-6" v-if="payment.payertype === 2">
                      <base-input
                        type="email"
                        rules="required"
                        label="Payer email"
                        placeholder="Payer email"
                        v-model="payment.payeremail"
                        name="Payer email"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </validation-observer>
              <div class="pl-lg-4">
                <base-button block type="primary" @click.native="onSave">Save changes</base-button>
              </div>
            </tab-pane>

            <tab-pane id="installment" :disabled="!payment.id">
              <span slot="title">Installments</span>
              <installments :paymentId="paymentid" :mindt="payment.startdate" :maxdt="payment.calcenddate"></installments>
            </tab-pane>
            <tab-pane id="payments" :disabled="!payment.id">
              <span slot="title">Payments</span>
              <payment-tran :paymentId="paymentid" :classId="payment.classid" :payerType="payment.payertype"></payment-tran>
            </tab-pane>
            <tab-pane id="debts" v-if="payment.payertype === 1" :disabled="!payment.id">
                <span slot="title">Debts</span>
                <students-debt :paymentId="paymentid" ></students-debt>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { GetClasses } from "../../../services/classes";
import {
  GetPayment,
  CreatePayment,
  UpdatePayment,
} from "../../../services/payments";
import { PaymentType } from "../../../services/types";
import { Tabs, TabPane } from "@/components";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Installments from "./Installments";
import PaymentTran from "./PaymentTran";
import StudentsDebt from "./StudentsDebt";
export default {
  components: {
    Tabs,
    TabPane,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    Installments,
    PaymentTran,
    StudentsDebt
  },
  props: {
    id: String,
  },
  computed: {
    mode() {
      return this.paymentid ? "Edit" : "Create";
    },
  },
  data() {
    return {
      isLoading: false,
      paymentid: this.id,
      payment: {},
      classes: [],
      types: [
        { id: 1, name: "Student" },
        { id: 2, name: "Class" },
      ],
    };
  },
  methods: {
    onSave() {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            CreatePayment(this.payment).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.paymentid = response.data.result;
                this.getPayment();
                
                this.notifyVue("success");
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdatePayment(this.payment).then((response) => {
              if (response.data.result) {
                this.notifyVue("success");
              } else {
                this.notifyVue("danger", response.data);
              }
              this.isLoading = false;
            });
          }
        }
      });
    },
    getPayment() {
      this.isLoading = true;
      GetPayment(this.paymentid).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.payment = response.data.result;
        } else {
          this.notifyVue("danger", response.data);
        }
      });
    },
    getClasses() {
      this.isLoading = true;
      GetClasses(1).then(response => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.classes = response.data.result;
        } else {
          this.classes = [];
          this.notifyVue("danger", response.data);
        }
      });
    },
  },
  mounted() {
      this.getClasses();
  },
  created() {
    if (this.mode === "Create") {
      this.payment = new PaymentType();
    } else {
        this.getPayment();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>